import { render, staticRenderFns } from "./BackgroundSelector.vue?vue&type=template&id=dd4aa964&"
import script from "./BackgroundSelector.vue?vue&type=script&lang=js&"
export * from "./BackgroundSelector.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundSelector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports